export default "__VITE_ASSET__BKiY9xnN__"